import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { ElementRef, NgZone, ViewChild } from '@angular/core';

import { AuthService } from '../../../shared/services/auth.service';
import { ControlBase, ControlTextbox } from '../../../shared/forms';

import { OrganizationService } from '../../../shared/services/organization.service';
import { Organization } from '../../../shared/models/organization.model';
import { StorageService } from '../../../shared/services/storage.service';
import { NgForm } from '@angular/forms/src/directives';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { Subscription } from 'rxjs/Rx';
import 'rxjs/add/observable/of';
import { v4 as uuid } from 'uuid';

// declare var google: any;
import { GeocodingService } from '../../../shared/services/geocode.service';
import { FileUpload } from '../../../shared/interfaces/fileupload';
import { UploadFileService } from '../../../shared/services/upload-service';
import { AfterViewInit } from '@angular/core';
import { AlertService } from '../../../shared/services/alert.service';
import { UtilityService } from '../../../shared/services/utility.service';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';


@Component({
    selector: 'appc-registerorg',
    templateUrl: './registerorg.component.html',
    styleUrls: ['./registerorg.component.scss']
})
export class RegisterorgComponent implements OnInit {

    @ViewChild("address")
    public searchElementRef: ElementRef;

    public websiteUrl: string;//created by venkat
    public webAddress: string;//created by venkat

    public facebookUrl: string;//created by venkat
    public facebookAddress: string;//created by venkat


    public twitterUrl: string;//created by venkat
    public twitterAddress: string;//created by venkat

    public youtubeUrl: string;//created by venkat
    public youtubeAddress: string;//created by venkat

    public linkedinUrl: string;//created by venkat
    public linkedinAddress: string;//created by venkat


    public latitude: number;
    public longitude: number;
    public lats: any;
    public lngs: any;
    public errorMessage: string;
    public displayErrorMessage: boolean;
    toggleNew: boolean = true;
    toggleEdit: boolean = false;
    iconUrlOrganisation: string;
    public searchControl: FormControl;
    public zoom: number;
    public center: any;
    public infoposition: boolean = true;
    private fragment: string;
    autocomplete: google.maps.places.Autocomplete;


    private errors: string[];
    private controls: ControlBase<any>[];
    interests: Array<string>;
    specializations: Array<any>;
    contacts: Array<object>;
    newSpecialization: Array<object>;
    oldSpecialization: any;

    subscription: Subscription;
    orgForm: FormGroup;
    organization: object;
    org: object;
    otherInterest: boolean = false;
    otherOrgType: boolean = false;
    newmode: boolean = true;
    selectedFiles: FileList
    selectedProfileFiles: FileList
    currentFileUpload: FileUpload
    profileFileUpload: FileUpload
    progress: { percentage: number } = { percentage: 0 }
    profileprogress: { percentage: number } = { percentage: 0 }

    lat: any;
    long: any;
    address: string;
    orgProjects: Array<any>;


    activeColor: string = 'green';
    baseColor: string = '#ccc';
    overlayColor: string = 'rgba(255,255,255,0.5)';

    dragging: boolean = false;
    loaded: boolean = false;
    profileloaded: boolean = false;
    imageLoaded: boolean = false;
    profileimageLoaded: boolean = false;
    //Riyan: Hiding progress bar when save and add project is clicked
    hideProgressBarCoverImage: boolean = false;
    hideProgressBarProfileImage: boolean = false;

    imageSrc: string = '../assets/img/empty.png';
    profileimageSrc: string = '../assets/img/empty.png';
    imageSrcName: string = '';
    profileimageName: string = '';

    iconColor: string;
    borderColor: string;

    disableButton: boolean;
    isSave: boolean = false;
    lstt: any;
    public centerPosition = [];

    public orgaddress: any = {};
    specializationRecord: Array<any>;
    public marker = {
        display: true,
        lat: null,
        lng: null,
        name: '',
        content: '',
        projId: '',
        orgId: '',
        projButton: false,
        orgButton: false,
        typeName: '',
        type: '',
        address: '',
        draggable: false,
        label: ''


    };


    public positions = [];


    constructor(public auth: AuthService,
        public router: Router,
        private storageService: StorageService,
        private route: ActivatedRoute,
        private organizationService: OrganizationService,
        private formBuilder: FormBuilder,
        private geocode: GeocodingService,
        private uploadService: UploadFileService,
        private alert: AlertService,
        private utility: UtilityService,
        private ref: ChangeDetectorRef,
        private ngZone: NgZone, private mapsAPILoader: MapsAPILoader,

    ) {
        this.disableButton = false;
        this.iconUrlOrganisation = '../../assets/img/markers/yellow-dot.png'


    }

    registerorg(model: any): void {

    };


    private setCurrentPosition() {
        this.zoom = 2;
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {

                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;

                this.zoom = 2;
            });
        }
    }

    getOrgPosition() {

        this.latitude = +this.storageService.getItem('latitude');
        this.longitude = +this.storageService.getItem('longitude');
        this.zoom = 2;
    }


    ngAfterViewInit() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }


    handleImageLoad() {
        this.imageLoaded = true;
        this.iconColor = this.overlayColor;
    }


    _handleReaderLoaded(e) {
        var reader = e.target;
        this.imageSrc = reader.result;
        this.loaded = true;
    }
    handleprofileImageLoad() {
        this.profileimageLoaded = true;
        this.iconColor = this.overlayColor;
    }


    _handleprofileReaderLoaded(e) {
        var reader = e.target;
        this.profileimageSrc = reader.result;
        this.profileloaded = true;
    }




    dragend(pos, $event) {
        this.displayErrorMessage = false;


        this.latitude = $event.coords.lat;
        this.longitude = $event.coords.lng;

        var latlng = new google.maps.LatLng(this.latitude, this.longitude);

        this.geocode.getLatLongDetail(latlng)
            .subscribe(address => {

                this.orgForm.controls['address'].setValue(address.formattedAddress)
                this.marker['address'] = address.formattedAddress

            })

    }


    selectAddress() {
        this.marker.display = !this.marker.display;

    }
    ///created by Vijay Kumar
    //modified by venkat
    organisationSpecs: IMockSpecs[] = [{ id: 1, name: 'Adolescents and Youth' },
    { id: 2, name: 'Agriculture' },
    { id: 3, name: 'Children' },
    { id: 4, name: 'Community Development' },
    { id: 5, name: 'Cultural Heritage, Preservation and Protection' },
    { id: 6, name: 'Disabled People' },
    { id: 7, name: 'Disaster Risk Reduction and Preparedness' },
    { id: 8, name: 'Economic Recovery and Development' },
    { id: 9, name: 'Education' },
    { id: 10, name: 'Emergency Response' },
    { id: 11, name: 'Energy and Extractives' },
    { id: 12, name: 'Environment' },
    { id: 13, name: 'Financial Services' },
    { id: 14, name: 'Fishing' },
    { id: 15, name: 'Food Security' },
    { id: 16, name: 'Forestry' },
    { id: 17, name: 'Health, Nutrition and Population' },
    { id: 18, name: 'Human Rights, Civil Liberties and Governance' },
    { id: 19, name: 'ICT - Information and Communication Technology' },
    { id: 20, name: 'Indigenous People' },
    { id: 21, name: 'Media and Journalism' },
    { id: 22, name: 'Peace and Security' },
    { id: 23, name: 'Post-Disaster Reconstruction and Rehabilitation' },
    { id: 24, name: 'Public Sector and Civil Society Capacity Building' },
    { id: 25, name: 'Refugees' },
    { id: 26, name: 'Rural Development' },
    { id: 27, name: 'Shelter and Housing' },
    { id: 28, name: 'Social Infrastructure and Services' },
    { id: 29, name: 'Urban Development' },
    { id: 30, name: 'Water, Sanitation and Hygiene' },
    { id: 31, name: 'Women and Girls' },
    { id: 32, name: 'Civil Society Capacity Building' },
    { id: 33, name: 'Construction' },

]

    areaofinterests: IMockSpecs[] = [
        { id: 40, name: 'Find Funding' },
        { id: 41, name: 'Access Resources' },
        { id: 34, name: 'Find Partners' },
        { id: 35, name: 'Access Data' },
        { id: 36, name: 'Increase Visibility' },
        { id: 37, name: 'Attend/Facilitate Workshops' },
        { id: 38, name: 'Attend/Facilitate Training' },
        { id: 39, name: 'Increase Network' }]
    user: IUser = {
        specs: [],
        areaOfIntrest: []
    }

    //The form
    get specs(): FormArray {
        return this.orgForm.get('specs') as FormArray;
    }

    get areaOfIntrest(): FormArray {
        return this.orgForm.get('areaOfIntrest') as FormArray;
    }

    buildSpecs(): FormArray {
        const arr = this.organisationSpecs.map(s => {
            return this.formBuilder.group({
                selected: false,
                id: s.id
            });
        });
        return this.formBuilder.array(arr);
    }

    buildAreaofIntrests(): FormArray {
        const arr1 = this.areaofinterests.map(aoi => {
            return this.formBuilder.group({
                selected: false,
                id: aoi.id
            })
        })
        return this.formBuilder.array(arr1)
    }
    //-------image preview----------//

    ngOnInit() {

        //create search FormControl
        this.searchControl = new FormControl();
        //load Places Autocomplete
        this.mapsAPILoader.load().then(() => {
            let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
                types: ["geocode"]
            });
            autocomplete.addListener("place_changed", () => {
                this.ngZone.run(() => {
                    //get the place result
                    let place: google.maps.places.PlaceResult = autocomplete.getPlace();

                    //verify result
                    if (place.geometry === undefined || place.geometry === null) {
                        return;
                    }

                    this.orgForm.controls['address'].setValue(place.formatted_address)
                    //set latitude, longitude and zoom
                    this.latitude = place.geometry.location.lat();
                    this.longitude = place.geometry.location.lng();
                    this.zoom = 10;
                    this.displayErrorMessage = false;
                });
            });
        });




        var userid = this.storageService.getItem('userid')
        // if (!this.auth.authState) {
        if (!userid) {
            //this.alert.showToast1("You have tried to access a memeber only Area. Please Sign Up and Sign In to contiue registration");
            this.storageService.addItem('auth2reg', "Please Sign in to register your organization");
            this.utility.signInWithMessageId("auth2reg");
        }

        this.interests = [];
        this.specializations = [];
        this.contacts = [];

        this.orgForm = this.formBuilder.group({
            name: [null],

            orgType: [''],
            address: [null],
            specs: this.buildSpecs(),
            areaOfIntrest: this.buildAreaofIntrests(),
            website: [''],
            facebooksite: [''],
            twittersite: [''],
            youtubesite: [''],
            linkedinsite: [''],
            contacts: this.formBuilder.array([
                this.initContact(),

            ]),

        });
        this.organizationService.getSpecialization()
            .subscribe(res => {
                this.newSpecialization = res;
            })


        this.subscription = this.route.params.subscribe(

            (param: any) => {

                let orgid = uuid();
                this.storageService.addItem("orgid", orgid);
                this.storageService.addMode("mode", param.mode);

                if (param.mode === 'edit') {
                    this.orgProjects = [];
                    this.newmode = false;
                    param.profileId ? this.organizationService.getOrganization(param.profileId)
                        .subscribe(
                        res => {

                            this.organization = res;
                            this.oldSpecialization = this.organization['specializations'];

                            //**added by venkt on 31-10-2017 for check boxes validations START*/
                            if (this.organization['specializations'] === undefined || this.organization['specializations'] === null) {
                                this.organization['specializations'] = [];

                            };
                            if (this.organization['interests'] === undefined || this.organization['interests'] === null) {
                                this.organization['interests'] = [];
                            };
                            //**added by venkt for check boxes validations END*/
                            this.orgProjects = this.organization['projects'];

                            this.storageService.addItem("orgid", param.profileId);
                            this.storageService.addItem("latitude", this.organization['latitude']);

                            if (this.organization !== null || this.organization !== undefined) {

                                this.orgForm = this.formBuilder.group({
                                    name: [this.organization['orgName'], Validators.required],

                                    orgType: [this.organization['orgType']],
                                    address: [this.organization['address'], Validators.required],
                                    contacts: this.formBuilder.array([]),
                                    website: [this.organization['website']],
                                    facebooksite: [this.organization['facebook']],
                                    twittersite: [this.organization['twitter']],
                                    youtubesite: [this.organization['youtube']],
                                    linkedinsite: [this.organization['linkedin']],
                                    projects: [this.orgProjects],
                                    specs: this.buildSpecsAfterFetch(this.organization['specializations']),
                                    areaOfIntrest: this.buildAoiAfterFetch(this.organization['interests']),
                                    //this.initContactAfterFetch(this.organization['contacts'])

                                })
                                this.contactsArray()



                                this.orgForm.controls['orgType'].setValue(this.organization['orgType'])
                                this.toggleNew = false;
                                this.toggleEdit = true;

                                this.storageService.addItem('latitude', this.organization['latitude'])
                                this.storageService.addItem('longitude', this.organization['longitude'])


                                //-------Riyan-------------------------------------------------------------
                                if (this.organization['coverPhoto'] == null || this.organization['profilePhoto'] == null) {

                                } else {
                                    this.imageSrc = this.organization['coverPhoto']['url'];
                                    this.imageSrcName = this.organization['coverPhoto']['name'];
                                    this.profileimageSrc = this.organization['profilePhoto']['url'];
                                    this.profileimageName = this.organization['profilePhoto']['name'];
                                    //-------Riyan-------------------------------------------------------------
                                }

                            }
                        }) : null;
                }
            }
        );

        var mode = this.storageService.getMode("mode");
        var lat = this.storageService.getItem("latitude");

        if (mode === "edit") {
            if (lat === '' || lat === undefined || lat === 'undefined') {

                this.setCurrentPosition();
                this.displayErrorMessage = true;
                this.errorMessage = 'Org Address not resolved on Map. Please edit and save.';

            } else {
                this.getOrgPosition()
                this.displayErrorMessage = false;

            }
        } else {
            this.setCurrentPosition();
        }
    }
    //-----------Contacts------------
    contactsArray() {
        const contactsArray = <FormArray>this.orgForm.controls['contacts'];
        if (this.organization['contacts'] === null || this.organization['contacts'] === undefined || this.organization['contacts'] === 'undefined' || this.organization['contacts'] === '') {

            this.addContact()
        } else {

            const contactsArray = <FormArray>this.orgForm.controls['contacts'];

            this.organization['contacts'].forEach(y => {

                contactsArray.push(this.initContactAfterFetch(y.contactName, y.contactEmail, y.contactPhone))
            })
        }
    }

    //-----------Contacts------------
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
    selectFile(e) {
        this.hideProgressBarCoverImage = false;
        this.selectedFiles = e.target.files;
        //Riyan: Hiding progress bar when save and add project is clicked
        if (this.selectedFiles.length == 0) {
            this.selectedFiles = null;
        } else {
            //-------Riyan-------------------------------------------------------------
            this.imageSrcName = e.target.files[0].name;
            //-------Riyan-------------------------------------------------------------
            var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

            var pattern = /image-*/;
            var reader = new FileReader();

            if (!file.type.match(pattern)) {
                alert('invalid format');
                return;
            }

            this.loaded = false;

            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsDataURL(file);
        }
    }

    upload() {
        this.hideProgressBarCoverImage = true;
        //Riyan: Hiding progress bar when save and add project is clicked
        if (this.selectedFiles == null || this.selectedFiles == undefined) {
            this.selectedFiles == null
        } else {
            const file = this.selectedFiles.item(0)
            this.currentFileUpload = new FileUpload(file);
            this.uploadService.pushFileToStorage(this.currentFileUpload, this.progress)
            this.selectedFiles = null;
        }

    }

    selectProfileFile(e) {
        this.hideProgressBarProfileImage = false;
        this.selectedProfileFiles = e.target.files;
        //Riyan: Hiding progress bar when save and add project is clicked
        if (this.selectedProfileFiles.length == 0) {
            this.selectedProfileFiles = null
        } else {
            //-------Riyan-------------------------------------------------------------
            this.profileimageName = e.target.files[0].name;
            //-------Riyan-------------------------------------------------------------
            var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

            var pattern = /image-*/;
            var reader1 = new FileReader();

            if (!file.type.match(pattern)) {
                alert('invalid format');
                return;
            }

            this.profileloaded = false;

            reader1.onload = this._handleprofileReaderLoaded.bind(this);
            reader1.readAsDataURL(file);
        }
    }

    profileUpload() {
        //Riyan: Hiding progress bar when save and add project is clicked
        this.hideProgressBarProfileImage = true;
        if (this.selectedProfileFiles == null || this.selectedProfileFiles == undefined) {
            this.selectedProfileFiles = null;
        } else {
            const file = this.selectedProfileFiles.item(0)
            this.profileFileUpload = new FileUpload(file);
            this.uploadService.pushFileToStorage(this.profileFileUpload, this.profileprogress)
            this.selectedProfileFiles = null;
        }


    }
    initContact(): FormGroup {
        return this.formBuilder.group({
            contactName: [],
            contactEmail: [],
            contactPhone: []
        });
    }

    initContactAfterFetch(x, y, z): FormGroup {


        if (x !== undefined || y !== undefined || z !== undefined) {
            return this.formBuilder.group({

                contactName: [x],
                contactEmail: [y],
                contactPhone: [z]
            });
        }
        else {

            return this.formBuilder.group({

                contactName: [],
                contactEmail: [],
                contactPhone: []

            });

        }

    }
    buildSpecsAfterFetch(specializations): FormArray {
        if (specializations != '' || specializations != 'undefined' || specializations != undefined) {
            const arr = this.organisationSpecs.map(s => {
                return this.formBuilder.group({
                    selected: [JSON.stringify(specializations).indexOf(s['name']) > 0 ? true : null],
                    id: s.id
                });
            })
            return this.formBuilder.array(arr);
        } else {
            const arr = this.organisationSpecs.map(s => {
                return this.formBuilder.group({
                    selected: false,
                    id: s.id
                });
            });
            return this.formBuilder.array(arr);
        }
    }

    buildAoiAfterFetch(interests): FormArray {
        if (interests != '' || interests != 'undefined' || interests != undefined) {
            const arr = this.areaofinterests.map(s => {
                return this.formBuilder.group({
                    selected: [JSON.stringify(interests).indexOf(s['name']) > 0 ? true : null],
                    id: s.id
                });
            })
            return this.formBuilder.array(arr);
        } else {
            const arr = this.areaofinterests.map(s => {
                return this.formBuilder.group({
                    selected: false,
                    id: s.id
                });
            });
            return this.formBuilder.array(arr);
        }
    }


    addContact() {
        const control = <FormArray>this.orgForm.get('contacts');
        control.push(this.initContact());

    }
    removeContact(i: number) {
        const control = <FormArray>this.orgForm.controls['contacts'];
        control.removeAt(i);
    }


    toggleVisibility(e, mode: string) {

        if (mode === 'interest') {
            this.otherInterest = e.target.checked;
        } else {
            this.otherOrgType = e.target.checked;

        }
    }


    placeChanged(place) {
        this.centerPosition = [];

        this.center = place.geometry.location;
        this.centerPosition.push(place.geometry.location)

        for (let i = 0; i < place.address_components.length; i++) {
            let addressType = place.address_components[i].types[0];
            this.orgaddress[addressType] = place.address_components[i].long_name;
        }
        this.ref.detectChanges();
    }
    clicked() {

    }


    onSave(x, isValid: boolean) {
        //venkat 14112017 start 
        if (isValid) {
            this.disableButton = true; // the button will then be disabled
        }
        //venkat 14112017 end
        this.processData();


        this.isSave = x === 'save' ? true : false;
        let msg = this.isSave ? ' Press OK to continue to view your profile OR cancel to continue editing  OR Cancel, and choose to add projects' : 'Press OK to create projects or cancel to continue editing profile ';
        let orgId = this.storageService.getItem('orgid')

        let org: LooseObject = {};
        org = this.organization;
        org['orgId'] = orgId;


        this.storageService.addItem('orgName', org.orgName)
        this.storageService.addItem('orgSpecialization', JSON.stringify(org.specializations))

        //this.geocode.getAddr(org['address'], this.saveGeoCodeResults, org, this.organizationService, this.router, this.isSave, this.orgProjects);
        if (this.orgProjects !== undefined) {
            org.projects = this.orgProjects;
        }
        this.organizationService.addOrganization(org);

        this.storageService.addItem('orgId', org['orgId']);
        if (this.isSave === true)

            this.router.navigateByUrl('/org/' + org['orgId']);
        else
            this.router.navigateByUrl('/registerproject/new/new');

    }

    processData() {




        //specializations 02-12-2017 by venkat
        const specials: any[] = <any[]>this.orgForm.value.specs.filter(x => x.selected);
        this.user.specs = <IMockSpecs[]>specials.map(x => this.organisationSpecs.find(y => y.id === x.id));
        for (var i = 0; i < this.user.specs.length; i++) {
            this.specializations.push(this.user.specs[i])
        }

        const aois: any[] = <any[]>this.orgForm.value.areaOfIntrest.filter(x => x.selected);
        this.user.areaOfIntrest = <IMockSpecs[]>aois.map(x => this.areaofinterests.find(y => y.id === x.id));
        for (var i = 0; i < this.user.areaOfIntrest.length; i++) {
            this.interests.push(this.user.areaOfIntrest[i]['name'])
        }

        //todo - ramesh srik please test
        this.orgForm.value.contacts.forEach(element => {

            this.contacts.push({
                'contactName': element.contactName,
                'contactEmail': element.contactEmail,
                'contactPhone': element.contactPhone

            });


        });

        // Vijay : Don't remove this i need to add defalut image for 
        var mode = this.storageService.getMode('mode')
        var organizationCoverPhoto = { url: '', name: '' };

        if (this.currentFileUpload == null || this.currentFileUpload == undefined) {
            if (mode === 'edit') {
                if (this.organization['coverPhoto'] == null) {
                    organizationCoverPhoto.url = "/assets/img/default_cover_img.jpg";
                    organizationCoverPhoto.name = 'default_cover_img.jpg';
                } else {
                    organizationCoverPhoto.url = this.organization['coverPhoto'].url;
                    organizationCoverPhoto.name = this.organization['coverPhoto'].name;
                }

            } else {
                organizationCoverPhoto.url = "/assets/img/default_cover_img.jpg";
                organizationCoverPhoto.name = 'default_cover_img.jpg';
            }
        } else {
            organizationCoverPhoto.url = this.currentFileUpload.url;
            organizationCoverPhoto.name = this.currentFileUpload.name;
        }

        var organizationProfilePhoto = { url: '', name: '' };
        if (this.profileFileUpload == null || this.profileFileUpload == undefined) {
            organizationProfilePhoto.url = "/assets/img/default_profile_img.jpg";
            organizationProfilePhoto.name = 'default_profile_img.jpg';
            //-------Riyan-------------------------------------------------------------
            var modeForImage = this.storageService.getItem('mode')
            if (modeForImage === 'edit') {
                if (this.organization['coverPhoto'] == null || this.organization['profilePhoto'] == null) {

                } else {
                    //alert(this.organization['coverPhoto']['url'])
                    organizationProfilePhoto['url'] = this.organization['profilePhoto']['url'];
                    organizationProfilePhoto['name'] = this.organization['profilePhoto']['name'];
                }
            }
            //-------Riyan-------------------------------------------------------------            

        } else {
            organizationProfilePhoto['url'] = this.profileFileUpload.url;
            organizationProfilePhoto['name'] = this.profileFileUpload.name;
        }
        // venkat start 18-11-2017
        this.websiteUrl = this.orgForm.value.website;

        if (this.websiteUrl === '' || this.websiteUrl === null || this.websiteUrl === undefined) {
            this.webAddress = '';
        } else {

            if (this.websiteUrl.indexOf('www') >= 0) {
                if (this.websiteUrl.indexOf('http') >= 0) {

                    this.webAddress = this.websiteUrl;
                }
                else {

                    this.webAddress = 'http://' + this.websiteUrl
                }

            } else {

                if (this.websiteUrl.indexOf('http') >= 0) {

                    this.webAddress = this.websiteUrl;
                } else {
                    this.webAddress = 'http://' + this.websiteUrl
                }
            }
        }
        // venkat end 18-11-2017
         // venkat start 22-11-2017
        
         this.facebookUrl = this.orgForm.value.facebooksite;
         if (this.facebookUrl === '' || this.facebookUrl === null || this.facebookUrl === undefined) {
             this.facebookAddress = '';
         } else {
 
         if (this.facebookUrl.indexOf('facebook.com') >= 0) {
             if(this.facebookUrl.indexOf('http') >= 0){
                 this.facebookAddress = this.facebookUrl;
             }
             else{
                 this.facebookAddress = 'https://'+this.facebookUrl
             }
            
         }
         else {
             this.facebookUrl = this.orgForm.value.facebooksite.replace('/', "");
             this.facebookAddress = 'https://www.facebook.com/' + this.facebookUrl
         }
     }
         this.twitterUrl = this.orgForm.value.twittersite;
         if (this.twitterUrl === '' || this.twitterUrl === null || this.twitterUrl === undefined) {
             this.twitterAddress = '';
         } else {
         if (this.twitterUrl.indexOf('twitter.com') >= 0) {
             if(this.twitterUrl.indexOf('http') >= 0){
                 this.twitterAddress = this.twitterUrl;
             }
             else{
                 this.twitterAddress = 'https://'+this.twitterUrl
             }
            
         }
         else {
             this.twitterUrl = this.orgForm.value.twittersite.replace('/', "");
             this.twitterAddress = 'https://www.twitter.com/' + this.twitterUrl
         }
     }
         this.youtubeUrl = this.orgForm.value.youtubesite;
         if (this.youtubeUrl === '' || this.youtubeUrl === null || this.youtubeUrl === undefined) {
             this.youtubeAddress = '';
         } else {
         if (this.youtubeUrl.indexOf('youtube.com') >= 0) {
             if(this.youtubeUrl.indexOf('http') >= 0){
                 this.youtubeAddress = this.youtubeUrl;
             }
             else{
                 this.youtubeAddress = 'https://'+this.youtubeUrl
             }
         }
         else {
             this.youtubeUrl = this.orgForm.value.youtubesite.replace('/', "");
             this.youtubeAddress = 'https://www.youtube.com/' + this.youtubeUrl
         }
     }
         this.linkedinUrl = this.orgForm.value.linkedinsite;
         if (this.linkedinUrl === '' || this.linkedinUrl === null || this.linkedinUrl === undefined) {
             this.linkedinAddress = '';
         } else {
         if (this.linkedinUrl.indexOf('linkedin.com') >= 0) {
             if(this.linkedinUrl.indexOf('http') >= 0){
                 this.linkedinAddress = this.linkedinUrl;
             }
             else{
                 this.linkedinAddress = 'https://'+this.linkedinUrl
             }
             
         }
         else {
             this.linkedinUrl = this.orgForm.value.linkedinsite.replace('/', "");
             this.linkedinAddress = 'https://www.linkedin.com/' + this.linkedinUrl
         }
     }
         // venkat end 22-11-2017

        this.organization = {

            'orgName': this.orgForm.value.name,
            'interests': this.interests,
            'coverPhoto': organizationCoverPhoto,
            'profilePhoto': organizationProfilePhoto,
            'orgType': this.orgForm.value.orgType,
            'specializations': this.specializations,
            'address': this.orgForm.value.address,
            'contacts': this.contacts,
            'website': this.webAddress,
            'facebook': this.facebookAddress,
            'twitter': this.twitterAddress,
            'youtube': this.youtubeAddress,
            'linkedin': this.linkedinAddress,
            'longitude': this.longitude,
            'latitude': this.latitude,
            'projects': [],

        };

    }



    private convertStringToNumber(value: string): number {
        return +value;
    }

}


interface LooseObject {
    [key: string]: any
}

interface IMockSpecs {
    id: any;
    name: string;
}

interface IUser {
    specs: IMockSpecs[],
    areaOfIntrest: IMockSpecs[]
}




// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/main/+forms/registerorg/registerorg.component.ts